export default {
  test_campaign_creation: {
    current: 0,
    maximum: 0,
    available: 0,
  },
  test_rating: {
    current: 0,
    maximum: 0,
    available: 0,
  }
}